import { inject, injectable } from "inversify";
import {
  CPLServiceChargeInvoicingSettingsClient,
  FileParameter,
  ServiceChargeInvoiceSettingsModel,
} from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IServiceChargeInvoiceSettingsService {
  getLogoURLs(): Promise<ServiceChargeInvoiceSettingsModel>;
  uploadHeaderLogo(headerImage: FileParameter): Promise<void>;
  uploadFooterLogo(footerImage: FileParameter): Promise<void>;
  deleteHeaderLogo(): Promise<void>;
  deleteFooterLogo(): Promise<void>;
}

@injectable()
export class ServiceChargeInvoiceSettingsService implements IServiceChargeInvoiceSettingsService {
  @inject(SERVICE_TYPES.CPLServiceChargeInvoicingSettingsClient)
  serviceChargeInvoicingSettingsClient!: CPLServiceChargeInvoicingSettingsClient;

  async uploadHeaderLogo(headerImage: FileParameter): Promise<void> {
    await this.serviceChargeInvoicingSettingsClient.uploadHeaderLogo({ image: headerImage });
  }

  async uploadFooterLogo(footerImage: FileParameter): Promise<void> {
    await this.serviceChargeInvoicingSettingsClient.uploadFooterLogo({ image: footerImage });
  }

  async getLogoURLs(): Promise<ServiceChargeInvoiceSettingsModel> {
    return await this.serviceChargeInvoicingSettingsClient.getLogoURLs();
  }

  async deleteHeaderLogo(): Promise<void> {
    await this.serviceChargeInvoicingSettingsClient.deleteHeaderLogo();
  }

  async deleteFooterLogo(): Promise<void> {
    await this.serviceChargeInvoicingSettingsClient.deleteFooterLogo();
  }
}
